import type {User, UserCredential, UserInfo} from 'firebase/auth';

//#region REGION - USER

//#region INTERFACE IUser

export interface IUser {
  id: string;
  userName: string;
  contactDetails?: IContactDetails;
  logState?: IStateLogger;
  logUser?: IUserLogger;
  personalDetails?: IPersonalDetails;
  pp?: string;
}

//#endregion

//#region CONST _DEFAULT_USER

/**
 * ### DEFAULT_USER
 * Default object conforming to the IUser interface.
 */
export const _USER_DEFAULT: Readonly<IUser> = {
  id: 'system',
  userName: 'System',
};

//#endregion

//#region INTERFACE IPersonalDetails
export interface IPersonalDetails {
  firstname?: string;
  lastname?: string;
}

//#endregion

//#region INTERFACE IContactDetails
export interface IContactDetails {
  cellphone?: string;
  email?: string;
}

//#endregion

//#endregion

//#region REGION - FIREBASE USER AND CREDENTIALS

//#region INTERFACE IFirebaseUserCredential

/**
 * ### IFirebaseUserCredential
 * Modular Firebase Auth credential type.
 */
export type IFirebaseUserCredential = UserCredential;

//#endregion

//#region INTERFACE IFirebaseUser

/**
 * ### IFirebaseUser
 * Modular Firebase Auth user type.
 */
export type IFirebaseUser = User;

//#endregion

//#region INTERFACE IFirebaseUserInfo

/**
 * ### IFirebaseUserInfo
 * Modular Firebase Auth user info type.
 */
export type IFirebaseUserInfo = UserInfo;

//#endregion

//#endregion

//#region REGION - TECHODACTYL ADMIN

//#region INTERFACE IUserLogger
export interface IUserLogger {
  logErrors?: boolean;
  logInfo?: boolean;
  logSuccess?: boolean;
}

//#endregion

//#region INTERFACE IStateLogger
export interface IStateLogger {
  logActions?: boolean;
  logState?: boolean;
}

//#endregion

//#region CONST _DEFAULT_USER_LOGGING
export const _DEFAULT_USER_LOGGING: Readonly<IUserLogger & IStateLogger> = {
  logActions: false,
  logErrors: false,
  logInfo: false,
  logState: false,
  logSuccess: false,
};

//#endregion

//#endregion